import React from "react";
import { Phone, Users, Check } from "lucide-react";
import styles from "./ourtents.module.css";

// Import your tent images
import tent1 from "../../assets/images/1.jpeg";
import tent2 from "../../assets/images/2.jpeg";
import tent3 from "../../assets/images/3.jpeg";
import tent4 from "../../assets/images/4.jpeg";
import tent5 from "../../assets/images/5.jpeg";
import tent6 from "../../assets/images/6.jpeg";
import tent7 from "../../assets/images/7.jpeg";
import tent8 from "../../assets/images/8.jpeg";

const tents = [
  {
    id: 1,
    image: tent1,
    title: "Lakeside Standard Tent",
    tag: "Lakeside",
    occupancy: "2-3 Guests",
    amenities: ["Lake View", "Bonfire Access"],
    description: "A comfy tent surrounded by lush forest and serene water."
  },
  {
    id: 2,
    image: tent2,
    title: "Riverfront Classic Tent",
    tag: "Riverfront",
    occupancy: "2-3 Guests",
    amenities: ["River View", "Fishing Access"],
    description: "Enjoy the serene river view directly from your tent doorway."
  },
  {
    id: 3,
    image: tent3,
    title: "Premium Glamping Tent",
    tag: "Glamping",
    occupancy: "2-4 Guests",
    amenities: ["Cozy Bedding", "Power Outlets"],
    description: "Glamping style tent with premium amenities and comfort setups."
  },
  {
    id: 4,
    image: tent4,
    title: "Family Adventure Tent",
    tag: "Family",
    occupancy: "4-5 Guests",
    amenities: ["Spacious Setup", "Kids Friendly"],
    description: "Spacious tent perfect for family stays and group retreats."
  },
  {
    id: 5,
    image: tent5,
    title: "Forest Explorer Tent",
    tag: "Forest",
    occupancy: "2 Guests",
    amenities: ["Woodland Trail", "Wildlife Spotting"],
    description: "Ideal for adventure seekers and deep nature explorers."
  },
  {
    id: 6,
    image: tent6,
    title: "Mountain View Tent",
    tag: "Scenic",
    occupancy: "2-3 Guests",
    amenities: ["Mountain View", "Trekking Area"],
    description: "Wake up to breathtaking mountain views and refreshing breeze."
  },
  {
    id: 7,
    image: tent7,
    title: "Sunset Serenade Tent",
    tag: "Lakeside",
    occupancy: "2-3 Guests",
    amenities: ["Sunset View", "Boating Nearby"],
    description: "Perfect spot with calming lake view to unwind and relax."
  },
  {
    id: 8,
    image: tent8,
    title: "Wilderness Retreat Tent",
    tag: "Secluded",
    occupancy: "2 Guests",
    amenities: ["Quiet Zone", "Star Gazing"],
    description: "Perfect secluded spot to enjoy stunning sunsets and starry nights."
  }
];

const OurTents = () => {
  return (
    <section className={styles.tentsSection}>
      <div className={styles.tentsInner}>
        
        {/* Header */}
        <div className={styles.tentsHeader}>
          <h2 className={styles.tentsTitle}>Our Tents</h2>
          <p className={styles.tentsSubtitle}>
            Explore our cozy and comfortable tents for a perfect camping experience by the lake.
          </p>
        </div>

        {/* Cards Grid */}
        <div className={styles.tentsGrid}>
          {tents.map((tent) => (
            <div key={tent.id} className={styles.tentCard}>
              
              {/* Image & Tag */}
              <div className={styles.tentImageWrapper}>
                <img src={tent.image} alt={tent.title} className={styles.tentImage} />
                <span className={styles.tagBadge}>{tent.tag}</span>
              </div>

              {/* Card Content */}
              <div className={styles.tentContent}>
                <div className={styles.tentTitleRow}>
                  <h3 className={styles.tentName}>{tent.title}</h3>
                  <div className={styles.occupancyBox}>
                    <Users size={14} className={styles.occupancyIcon} />
                    <span>{tent.occupancy}</span>
                  </div>
                </div>

                <p className={styles.tentDescription}>{tent.description}</p>

                {/* Amenities List */}
                <div className={styles.amenitiesContainer}>
                  {tent.amenities.map((amenity, idx) => (
                    <div key={idx} className={styles.amenityBadge}>
                      <Check size={12} className={styles.checkIcon} />
                      <span>{amenity}</span>
                    </div>
                  ))}
                </div>

                {/* Call Button */}
                <a href="tel:919435851141" className={styles.callBtn}>
                  <Phone size={15} />
                  <span>Call for Booking</span>
                </a>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurTents;

